import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { selectEasymsCategories } from '../../../../../../selectors/dobovoSelectors/dobovoEasymsSelector'
import ApartmentEditDialog from './ApartmentEditDialog'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    active: {
        color: '#4caf50'
    },
    notActive: {
        color: '#f44336'
    }
})

class ApartmentsTable extends React.Component {
    state = {
        openId: null
    }

    handleUpdate = organization => {
        this.props.onUpdate(organization)
    }

    handleOpenDialog = openId => () => {
        this.setState({ openId })
    }

    handleCloseDialog = () => {
        this.setState({ openId: null })
    }

    handleDelete = remoteId => () => {
        const toastrConfirmOptions = {
            onOk: () => this.props.onDelete(remoteId)
        }
        toastr.confirm('Вы уверены, что хотите удалить категорию?', toastrConfirmOptions)
    }

    render() {
        const { classes, apartments = [] } = this.props
        const { openId } = this.state

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID организации Dobovo.com</TableCell>
                            <TableCell>Апартаменты Dobovo.com</TableCell>
                            <TableCell>Организация EasyMS</TableCell>
                            <TableCell>ID категории EasyMS</TableCell>
                            <TableCell>ID тарифа EasyMS</TableCell>
                            <TableCell>Активен?</TableCell>
                            <TableCell padding="checkbox" />
                            <TableCell padding="checkbox" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {apartments.map(item => (
                            <TableRow hover key={item.remoteApartmentsId}>
                                <TableCell>{item.remoteOrganizationId}</TableCell>

                                <TableCell>
                                    <span>
                                        <em>{item.remoteApartmentsName}</em>
                                        <strong>{' (id: ' + item.remoteApartmentsId + ')'}</strong>
                                    </span>
                                </TableCell>

                                <TableCell>
                                    <span>
                                        <em>{item.ourOrganizationName}</em>
                                        <strong>{' (id: ' + item.ourOrganizationId + ')'}</strong>
                                    </span>
                                </TableCell>

                                <TableCell>{item.ourCategoryId}</TableCell>
                                <TableCell>{item.rateId}</TableCell>

                                <TableCell>
                                    {item.active ? (
                                        <strong className={classes.active}>АКТИВНА</strong>
                                    ) : (
                                        <strong className={classes.notActive}>НЕ АКТИВНА</strong>
                                    )}
                                </TableCell>

                                <TableCell padding="none">
                                    <IconButton
                                        aria-label="Edit"
                                        onClick={this.handleOpenDialog(item.remoteApartmentsId)}
                                    >
                                        <EditIcon />
                                    </IconButton>

                                    {openId === item.remoteApartmentsId && (
                                        <ApartmentEditDialog
                                            item={item}
                                            open={openId === item.remoteApartmentsId}
                                            onOpen={this.handleOpenDialog}
                                            onClose={this.handleCloseDialog}
                                            onUpdate={this.handleUpdate}
                                        />
                                    )}
                                </TableCell>
                                <TableCell padding="none">
                                    <IconButton
                                        title="Delete"
                                        aria-label="Delete"
                                        onClick={this.handleDelete(item.remoteApartmentsId)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}
ApartmentsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    apartments: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired
}

export default connect(state => ({
    easymsCategories: selectEasymsCategories(state)
}))(withStyles(styles)(ApartmentsTable))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/ApartmentsTab/ApartmentsTable/ApartmentsTable.js